import {
  DateComparisonSchema,
  StringGenerator,
} from "@graffer-inc/form-schema";
import { AllowedTermInput } from "./allowed-term-input";
import { useMemo } from "react";

type Props = {
  schema?: DateComparisonSchema;
};

export const AllowedTermValidationEditor: React.FC<Props> = ({ schema }) => {
  const keyedSchemaValues = useKeyedArray(schema?.value);

  return (
    <div>
      <div className="field">
        <label className="label">許容日付期間</label>
      </div>
      {schema ? (
        <div className="columns">
          <div className="column ml-4">
            {keyedSchemaValues.map(([key, value], index) => (
              <AllowedTermInput
                key={key}
                identifier={key}
                index={index}
                value={value}
              />
            ))}
          </div>
        </div>
      ) : (
        <div>設定なし</div>
      )}
    </div>
  );
};

// Array#map でコンポーネントを描画するに際して、
// React の文脈で unique な key を付与できるようにしている。
const useKeyedArray = <T,>(arr: T[] | undefined): Array<[string, T]> => {
  const base = arr ?? [];
  const keys = useMemo(() => {
    return StringGenerator.generateUniqueIDs(base.length);
  }, [
    // 要素の入れ替えはサポートしていないので、
    // length が変わったときのみ再計算する、でよい
    base.length,
  ]);
  return keys.map((id, index) => [id, base[index]]);
};
